export default __webpack_public_path__ + "static/media/Tiger's Bracers of the Elder Bond.c70fe711.jpg";